import MuiDivider, { DividerProps } from '@mui/material/Divider';

export interface IDividerProps extends DividerProps {}

const Divider = (props: IDividerProps): JSX.Element => {
  return <MuiDivider {...props} />;
};

export default Divider;
